import colors from '@legacy/moon/particles/colors';

import AreaGraph from './AreaGraph';
import AreaGraphError from './components/AreaGraphError';
import AreaGraphLoader from './components/AreaGraphLoader';

import { AreaGraphWrapperProps } from './types';

const AreaGraphWrapper = ({
  loading,
  data,
  dataMin,
  dataMax,
  hasError = false,
  color = colors.borealis60,
  customTooltip,
  handleError,
  colorID,
}: AreaGraphWrapperProps): JSX.Element | null => {
  if (loading) return <AreaGraphLoader />;
  if (hasError) return <AreaGraphError handleError={handleError} />;
  if (!data || (data && data.length <= 1)) return null;
  return (
    <AreaGraph
      data={data}
      dataMin={dataMin}
      dataMax={dataMax}
      color={color}
      customTooltip={customTooltip}
      colorID={colorID}
    />
  );
};

export default AreaGraphWrapper;
